/**
 * THE CORRECTION WORKFLOW — Request -> Verify -> Approve (desk, 2026-10-05).
 *
 * Who verifies and who approves is a SELECTION of named users made in Administration → Correction Workflow; this service reads
 * and saves it, tells the signed-in user what they can do (`me`), and fetches the ONE combined list the verifier / approver
 * screen works from. Plain `httpClient`/`unwrap` like the two correction services: no OpenAPI registration, so the generated
 * client's typed path map does not cover it.
 */
import { httpClient, unwrap, API_ENDPOINTS } from '@core/api';
import type { ApiSuccessResponse } from '@app-types/api.types';
import type {
  CorrectionDesignationsDto,
  CorrectionRequestsDto,
  CorrectionWorkflowMeDto,
  PaymentCorrectionStatus,
  SetCorrectionDesignationsInput,
} from '@nexao/contracts';

const BASE = API_ENDPOINTS.financial.correctionWorkflow;

export async function getCorrectionDesignations(): Promise<CorrectionDesignationsDto> {
  return unwrap(httpClient.get<ApiSuccessResponse<CorrectionDesignationsDto>>(`${BASE}/designations`));
}

export async function setCorrectionDesignations(input: SetCorrectionDesignationsInput): Promise<CorrectionDesignationsDto> {
  return unwrap(httpClient.put<ApiSuccessResponse<CorrectionDesignationsDto>>(`${BASE}/designations`, input));
}

/** What the signed-in user can do, and how much is waiting for THEM. Safe for every user: it describes only themself. */
export async function getCorrectionWorkflowMe(): Promise<CorrectionWorkflowMeDto> {
  return unwrap(httpClient.get<ApiSuccessResponse<CorrectionWorkflowMeDto>>(`${BASE}/me`));
}

/** `mine: true` = the requests I entered (any user); without it = everything (selected verifiers / approvers and overseers only). */
export async function listCorrectionRequests(query: { status?: PaymentCorrectionStatus; mine?: boolean }): Promise<CorrectionRequestsDto> {
  return unwrap(
    httpClient.get<ApiSuccessResponse<CorrectionRequestsDto>>(`${BASE}/requests`, {
      params: { ...(query.status ? { status: query.status } : {}), ...(query.mine ? { mine: 'true' } : {}) },
    }),
  );
}
